import React, { useEffect, useRef, useState } from 'react'
import { StyleSheet } from 'react-native'

import { Stack } from '@zet/design-system'

import { useAutoComplete } from '../../../api/autoComplete/hooks/useAutoComplete'
import { useApiAction } from '../../../api/useApiAction'
import useFormStore from '../../formBuilder/store'
import { RadioButton } from '../radioButton'
import SelectDropDown from '../selectDropDown'

interface Props {
  label: string
  placeholder: string
  onChange: (arg: any) => void
  onBlur: () => void
  value: string
  errorMessage: string
  isRequired: boolean
  dropdownMode: string
  isSearchable: boolean
  searchEndPoint: string
  options: any
  fieldId: string
  ocFieldCode: string
  data: {
    state: string
    city: string
  }
  radioStepperProps: {
    label: string
    onChange: (arg: string) => void
    onBlur: () => void
    fieldOptions: FieldOptions[]
    isRequired?: boolean
  }
  autoCompleteLength: number
}

interface FieldOptions {
  optionId: string
  optionValue: string
  orderNo?: number
  recommended?: boolean
  recommendationKey?: string
  showField?: string
  description?: string
}

export default function BankAggregatorSelector({
  label = 'Select Dropdown',
  placeholder = 'Select',
  onChange,
  onBlur,
  value,
  errorMessage,
  isRequired = true,
  dropdownMode = 'single',
  isSearchable = false,
  searchEndPoint,
  options,
  fieldId,
  ocFieldCode,
  data,
  radioStepperProps,
  autoCompleteLength = 3,
}: Props) {
  const dropDownRef = useRef<any>(null)
  const { params, setParams } = useFormStore((state) => state)
  const [radioButtonOptions, setRadioButtonOptions] = useState<FieldOptions[]>(
    radioStepperProps.fieldOptions
  )
  const { data: list } = useApiAction()
  const { data: pincodeData, refetch: getAutoComplete } = useAutoComplete(
    value,
    fieldId,
    ocFieldCode,
    '',
    list?.metadata?.leadId ?? ''
  )

  useEffect(() => {
    const data: any = dropDownRef?.current?.getFieldValue(value)
    if (data) {
      const radioButtonData = JSON.parse(data?.data)
      changeRadioButtonOptions(radioButtonData)
    }
  }, [value])

  const setOptionValue = (option: string) => {
    return option === 'Y'
  }

  const changeRadioButtonOptions = (optionConfig: any) => {
    let optionsArray = radioStepperProps.fieldOptions.filter(
      (item: FieldOptions) => {
        let temp = { ...item }
        if (setOptionValue(optionConfig[temp?.showField])) {
          temp.recommended = setOptionValue(
            optionConfig[temp?.recommendationKey]
          )
          setOptionValue(optionConfig[temp?.showField])
          return temp
        }
        return false
      }
    )
    setRadioButtonOptions(optionsArray)
  }

  return (
    <Stack>
      <SelectDropDown
        ref={dropDownRef}
        label={label}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        isRequired={isRequired}
        dropdownMode={dropdownMode}
        isSearchable={isSearchable}
        errorMessage={errorMessage}
        searchEndPoint={searchEndPoint}
        options={options}
        fieldId={fieldId}
        ocFieldCode={ocFieldCode}
        autoCompleteLength={autoCompleteLength}
      />
      <Stack className="mt-6">
        <RadioButton
          label={radioStepperProps.label}
          onChange={(value: string) => {
            setParams({ event: value })
          }}
          onBlur={() => {}}
          optionStyleProps={{
            optionTextStyle: 'w-[100%] ml-2',
          }}
          isRequired={radioStepperProps.isRequired}
          fieldOptions={radioButtonOptions}
          value={params?.event}
          ocFieldCode={'income_verification'}
        />
      </Stack>
    </Stack>
  )
}

const styles = StyleSheet.create({
  textInput: {
    marginTop: 8,
  },
})
